/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { ConfirmAccountPage as SourceConfirmAccountPage } from 'SourceRoute/ConfirmAccountPage/ConfirmAccountPage.component';
import ContentWrapper from 'Component/ContentWrapper';
import Field from 'Component/Field';
import Form from 'Component/Form';
import Loader from 'Component/Loader';
import { convertQueryStringToKeyValuePairs } from 'Util/Url';
import { isSignedIn } from 'Util/Auth';

import './ConfirmAccountPage.style';

/** @namespace Route/ConfirmAccountPage/Component */
export class ConfirmAccountPage extends SourceConfirmAccountPage {
    renderForm() {
        const {
            onConfirmAttempt,
            onConfirmSuccess,
            onFormError,
            email
        } = this.props;

        // TODO: use FieldForm instead!!!

        return (
            <Form
                mix={{ block: 'ConfirmAccountPage', elem: 'Form' }}
                key="confirm-account"
                onSubmit={onConfirmAttempt}
                onSubmitSuccess={onConfirmSuccess}
                onSubmitError={onFormError}
            >
                { /*
                    Added email field with display:none to fix warning
                    `Password forms should have (optionally hidden) username fields for accessibility`
                */ }
                <Field
                    type="email"
                    label={__('Email')}
                    id="email"
                    name="email"
                    // Added value to make sure autocomplete does not change the value of hidden field
                    value={email}
                    mix={{ block: 'ConfirmAccountPage', elem: 'EmailInput' }}
                />
                <Field
                    type="password"
                    label={__('Password')}
                    id="password"
                    name="password"
                    placeholder={__('Enter your password')}
                    validation={['notEmpty', 'password']}
                />
                <button
                    type="submit"
                    block="Button"
                    mix={{ block: 'ConfirmAccountPage', elem: 'Button' }}
                >
                    {__('Confirm your account')}
                </button>
            </Form>
        );
    }
}

export default ConfirmAccountPage;
